import { useEffect, useState } from "react";
import { CustomDataGrid } from "../../../common/components/Table/CustomDataGrid";
// import { reviewerGridColumns } from "../utilis/reviewerGridColumns";
import { getReviewerHeaders, load_reviewer_data_from_backend } from "../utilis/reviewerServices";
import { LinearProgress } from "@mui/material";

const TabContent = ({ tabName, hiddenColumns }) => {
    // console.log(hiddenColumns);
    const [columns, setColumns] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // to fetch columns async
    const fetchColumns = async () => {
        const columns = await getReviewerHeaders();
        setColumns(Object.values(columns));
    };

    useEffect(() => {
        fetchColumns();
        load_reviewer_data_from_backend(data, setData, tabName, setLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabName]);
    return (
        <>
            {
                columns && data && <CustomDataGrid
                    loading={loading}
                    pagination
                    columns={columns}
                    rows={data || []}
                    initialState={{
                        columns: {
                            columnVisibilityModel: hiddenColumns,
                        },
                        pinnedColumns: {
                            right: [
                                "reviewers_remark"
                            ]
                        },
                        pagination: { paginationModel: { pageSize: 25 } },
                    }}
                    slots={{
                        loadingOverlay: LinearProgress,
                    }}
                    sx={{
                        height: "700px"
                    }}

                />
            }
        </>
    );
};
export default TabContent;